import styled from 'styled-components';

import { mediaQuery } from '@savgroup-front-common/core/src/grid/helpers';

export const $LeftColumn = styled.div``;

export const $HeadingIcon = styled.span`
  margin-right: 1rem;
  display: flex;
  align-items: baseline;
  & svg {
    width: 24px;
    height: 24px;
  }
`;

export const $DepositWrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;
  ${mediaQuery.sm`
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-gap: 2rem;
  `};
`;

export const $DepositItemWrapper = styled.div`
  flex: 1;
`;

export const $DepositResultWrapper = styled.div`
  flex: 1;
  margin-bottom: 2rem;
`;
